import { defineComponent, computed } from "vue";
import ChargerBox from "./component-library73.mjs";
import ChargerLabel from "./component-library72.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "charger",
  props: {
    chargerIncluded: { type: Boolean, default: null },
    pd: { type: Boolean, default: null },
    watts: { type: String, default: null },
    commonCharger: {
      type: Object,
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const isPossible = computed(() => {
      if (!props.commonCharger)
        return true;
      return props.commonCharger.possible === true;
    });
    const isIncluded = computed(() => {
      var _a, _b;
      if (props.chargerIncluded !== null)
        return props.chargerIncluded;
      if (((_a = props.commonCharger) == null ? void 0 : _a.included) === true)
        return true;
      if (((_b = props.commonCharger) == null ? void 0 : _b.included) === false)
        return false;
      return null;
    });
    const hasPd = computed(() => {
      var _a, _b;
      if (props.pd)
        return props.pd;
      if (((_a = props.commonCharger) == null ? void 0 : _a.usbPd) === true)
        return true;
      if (((_b = props.commonCharger) == null ? void 0 : _b.usbPd) === false)
        return false;
      return false;
    });
    const wattsText = computed(() => {
      var _a, _b;
      if (props.watts)
        return props.watts;
      if (((_a = props.commonCharger) == null ? void 0 : _a.minWattage) || ((_b = props.commonCharger) == null ? void 0 : _b.maxWattage)) {
        return [props.commonCharger.minWattage, props.commonCharger.maxWattage].filter(Boolean).join("-");
      }
      return null;
    });
    return { __sfc: true, props, isPossible, isIncluded, hasPd, wattsText, ChargerBox, ChargerLabel };
  }
});
export {
  _sfc_main as default
};
